module.exports = __webpack_public_path__ + "img/icon1.571ab0b9.svg";